import { pipe, filter, join } from 'ramda'
const pageTitle = pipe(
	filter(Boolean),
	join(' · '),
);
export default pageTitle;